<template>
    <v-dialog v-model="dialog" max-width="1000" style="background-color: red;" v-resize="onResize">
        <v-card v-if="isReady" class="standard-row font-theme"
            style="border: 1px solid #000000; border-radius: 20px; padding: 5px 1px 14px 20px;">
            <v-card-title v-if="windowSize.x > 850" class="d-flex justify-space-between align-center"
                style="padding: 0px;">
                <v-row no-gutters class="standard-row" style="font-size: 12px; padding: 14px 14px 14px 0px;">
                   <v-btn rounded color="#ffffff" class="ml-auto black--text text-center download-report-vendor-btn"
                    @click="downloadFile">
                    <img src="../assets/excel.png" alt="Excel Icon" width="30" class="mr-2" />
                    ตัวอย่างไฟล์ Import Excel
                </v-btn>
                  <v-btn rounded color="green" class="white--text text-center download-report-vendor-btn ml-2"
                          @click="addFileExcel">
                        <v-icon class="mr-1">mdi-plus</v-icon> Import Excel
                    </v-btn>
                </v-row>
            </v-card-title>
            <v-card-title v-else class="d-flex justify-end align-center" style="padding: 14px 14px 14px 0px;">
                        <v-btn rounded color="green" class="ml-auto white--text text-center download-report-Item-btn"
                            @click="addFileExcel">
                            <v-icon class="mr-1">mdi-plus</v-icon> Import Excel
                        </v-btn>
            </v-card-title>
            <div class="scroll-theme add-Item-detail-scroll">
                <v-form lazy-validation ref="headerForm">
                    <template>
                        <p style="font-size: 32px; font-weight: 700;" class="mb-0">ITEM</p>
                        <v-row no-gutters class="standard-row mb-7">
                            <v-col v-for="(item, index) in detailItem.Item" :key="`title_${index}`" cols="12" sm="6"
                                md="6" lg="6" class="mt-3 mt-md-1" style="font-size: 14px;">
                                <v-row no-gutters class="standard-row">
                                    <v-col cols="12" sm="12" md="5" :lg="!(index + 1) % 2 ? '6' : '5'"
                                        style="font-weight: 700;" class="pr-sm-3">
                                        {{ index }}
                                    </v-col>
                                    <v-col cols="12" sm="12" md="7" :lg="!(index + 1) % 2 ? '6' : '7'" class="pr-sm-3">
                                        <v-text-field hide-details outlined height="25" v-model="dataInputs[item]"
                                            type="text" color="black"
                                            class="py-0 font-theme border-radius-box margin-left-text-field total-value-pr-create-doc"
                                            :rules="textRules" required></v-text-field>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </template>
                    <v-row class="standard-row text-center d-flex justify-end create-document-row">
                        <div class="mr-3">
                            <v-btn rounded @click="closeDialog()" color="red"
                                class="elevation-0 font-theme confirm-btn white--text mr-2"
                                style="width: 100px; height: 35px;">
                                ยกเลิก
                            </v-btn>
                            <v-btn rounded @click="submitForm()" color="#0B68D6"
                                class="elevation-0 font-theme confirm-btn white--text ml-1"
                                style="width: 100px; height: 35px;">
                                ยืนยัน
                            </v-btn>
                        </div>
                    </v-row>
                </v-form>
            </div>
        </v-card>
        <addExcelModal/>
    </v-dialog>
</template>

<script>
import { EventBus } from '../EventBus'
import addExcelModal from '../components/addExcelModal.vue'
export default {
    components: {
            addExcelModal
    },
    data: () => ({
        textRules: [v => !!v],
        dialog: false,
        isReady: false,
        detailItem: {},
        dataInputs: {},
        windowSize: { x: 0 },
        fileName: null,
        file: null,
    }),
    watch: {
        "dialog"(newVal) {
            if (!newVal) {
                this.dataInputs = []
                this.fileName = null;
                this.file = null;
            }
        }
    },
    computed: {
        selectedBiz() {
            return this.$store.state.confirmSelectedBiz
        },
    },
    mounted() {
        EventBus.$on('openAddItemDetail', this.openDialog)
        EventBus.$on('offDialog', this.closeDialog);
    },
    beforeDestroy() {
        EventBus.$off('openAddItemDetail')
        EventBus.$off('offDialog')
    },
    methods: {
        openDialog() {
            this.isReady = false
            this.detailItem = {
                Item: {
                    'Material Code': 'material_code',
                    'Material Name': 'material_name',
                    'Objective Code': 'objective_code',
                    'Objective Name': 'objective_name',
                    'GL Account': 'gl_account',
                    'GL Account Name': 'gl_account_name',
                },
            };

            this.$nextTick(() => {
                this.dialog = true
                this.isReady = true
                document.getElementsByClassName('v-dialog--active')[0] ? document.getElementsByClassName('v-dialog--active')[0].scrollTop = 0 : null
            })
        },
        
        addFileExcel() {
            EventBus.$emit('uploadFileExcel','Item')
        },

        closeDialog() {
            this.dialog = false;
        },
        async submitForm() {
            if (this.$refs.headerForm.validate()) {
                this.ListDetailItem = {
                        Run_Code2: this.dataInputs['material_code'],
                        Discription: this.dataInputs['material_name'],
                        Object_Code: this.dataInputs['objective_code'],
                        Objective: this.dataInputs['objective_name'],
                        GL_Debit: this.dataInputs['gl_account'],
                        GL_Account_Name: this.dataInputs['gl_account_name'],
                        Company: this.selectedBiz.company_full_name,
                };
                try {
                    const { data } = await this.axios.post(
                        `${this.$api_url}/item_erp/api/v1/create_itemerp`,
                        this.ListDetailItem
                    )
                    if (data.status) {
                        this.alert('เพิ่มข้อมูลสำเร็จ', 'Success', 'success')
                        this.dialog = false;
                    } else {
                        this.alert('เพิ่มข้อมูลไม่สำเร็จ', 'Fail', 'error')
                    }
                } catch (error) {
                    this.alert('เพิ่มข้อมูลไม่สำเร็จ', 'Fail', 'error')
                    console.log(error);
                }

            } else {
                this.alert('กรอกข้อมูลให้ครบถ้วน', 'Warning', 'info')
            }
        },
        onResize() {
            this.windowSize = { x: window.innerWidth }
        },
        downloadFile() {
            const link = document.createElement('a');
            link.href = '/file/item_list.xlsx'; // Path relative to the public directory
            link.download = 'item_list.xlsx'; // Adjust the download file name as necessary
            link.click();
            this.alert('ดาวน์โหลดไฟล์สำเร็จ', 'Success', 'success');
        },
        alert(title = '', text = 'Fail', icon = 'info') {
            this.$swal({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                icon: icon,
                title: `<b class="alert-success-title">${title}</b>`,
                text: text,
                showClass: {
                    popup: 'animate-show-card'
                },
                customClass: {
                    container: 'alert-card-block',
                    popup: 'alert-card-success',
                    title: 'alert-title-block',
                    htmlContainer: 'alert-text-box',
                    icon: 'alert-icon'
                }
            })
        }
    }
}
</script>

<style>
.add-Item-detail-scroll {
    padding-right: 10px;
    color: black;
    overflow-y: auto;
    border-radius: 0px !important;
    max-height: calc(100vh - 158px);
}

@media only screen and (max-width: 600px) {
    .add-Item-detail-scroll {
        max-height: calc(100vh - 238px) !important;
    }
}
</style>